'use client'

import React from 'react'

import { CloseOval } from '../../icons'
import { Clear, Container, Label, Selection } from './styles'

export interface SelectionsProps<T extends string | number = string | number> {
  value: {
    id: T
    label: React.ReactNode
  }[]
  onClick: (id: T) => void
  onClear: (id: T) => void
}

export const Selections = <T extends string | number = string | number>({
  value,
  onClick,
  onClear,
}: SelectionsProps<T>) => {
  return (
    <Container>
      {value.map(({ id, label }) => (
        <Selection key={id}>
          <Label
            type="button"
            onClick={(e) => {
              e.preventDefault()
              onClick(id)
            }}
          >
            {label}
          </Label>
          <Clear
            type="button"
            onClick={(e) => {
              e.preventDefault()
              onClear(id)
            }}
          >
            <CloseOval />
          </Clear>
        </Selection>
      ))}
    </Container>
  )
}
